import cx from "classnames";
import { Link, useLocation } from "react-router-dom";
import { subdomainTypes } from "../../../context/availableSubdomains";
import SidebarSection from "../SidebarSection";
import { menuLinks } from "./data";
import ExternalLink from "../../../assets/externalLink";
import Icon from "../../Icon/icon";
import { MenuSection } from "./data";

interface GeneralMenuProps {
  appBranch: subdomainTypes | "";
  sections?: MenuSection[];
}

const GeneralMenu = ({ appBranch, sections = menuLinks }: GeneralMenuProps) => {
  const userBrands = localStorage.getItem("brands") ?? "";
  const { pathname } = useLocation();

  const visibleSections = sections
    .map((section) => ({
      ...section,
      itemsPerRow: section.itemsPerRow ?? 3,
      visibleLinks: section.links.filter((link) => !link.brand || userBrands.includes(link.brand)),
    }))
    .filter((section) => section.visibleLinks.length > 0);

  return (
    <>
      {visibleSections.map((section) => (
        <SidebarSection title={section.title} key={section.title}>
          <div
            className={cx("sidebar-link-group", `sidebar-link-group--cols-${section.itemsPerRow}`)}
          >
            {section.visibleLinks.map((link) => {
              const route =
                typeof link.route === "string"
                  ? link.route
                  : link.route[appBranch as subdomainTypes];
              const isSelected = !link.externalLink && pathname.startsWith(route);
              return (
                <Link
                  key={link.title}
                  to={route}
                  className={cx("sidebar-link", {
                    selected: isSelected,
                    "sidebar-link--full": link.fullWidth,
                    "sidebar-link--external": link.externalLink,
                    "sidebar-link--mobile-hidden": link.mobileHidden,
                  })}
                  target={link.externalLink ? "_blank" : undefined}
                  rel="noreferrer"
                >
                  {link.icon && (
                    <span className="sidebar-link__icon">
                      <Icon name={link.icon} />
                    </span>
                  )}
                  <div className="sidebar-link__content">
                    <span className="sidebar-link__label">{link.title}</span>
                    {link.description && (
                      <p className="sidebar-link__description">{link.description}</p>
                    )}
                  </div>
                  {link.externalLink && (
                    <span className="sidebar-link__meta">
                      External
                      <ExternalLink width={14} fill="white" />
                    </span>
                  )}
                </Link>
              );
            })}
          </div>
        </SidebarSection>
      ))}
    </>
  );
};

export default GeneralMenu;
